import { ICONS } from "assets/icons";
import SequencePreview from "assets/customSVG/sequence/SequencePreview";
import Whatsapp from "assets/customSVG/Whatsapp";
import Website from "assets/customSVG/sequence/Website";
import Instagram from "assets/customSVG/sequence/Instagram";
import Meta from "assets/customSVG/sequence/Meta";
import QRCode from "assets/customSVG/sequence/QRCode";
import FB from "assets/customSVG/sequence/FB";
import Broadcast from "assets/customSVG/sequence/Broadcast";
import WebhookIcon from "assets/customSVG/campaigns/WebhookIcon";
import Key from "assets/customSVG/Key";
import FollowUpTimer from "assets/customSVG/sequence/FollowUpTimer";
import Assignee from "assets/customSVG/sequence/actions/Assignee";

export const MAX_SEQUENCE_LENGTH = 64;

export const MAX_NODE_BASED_ON_PLANS = {
  "starter": 80,
  "growth": 80,
  "magnum": 80,
};

export const ALLOWED_STATUS_TO_EDIT_FLOW = ["DRAFT", "NEW"];

export const SEQUENCE_STATUS_STYLES = {
  DRAFT: {
    bg: "#CAD3E8",
    color: "var(--contentText)",
    text: "Draft",
    icon: null,
  },
  NEW: {
    bg: "#CAD3E8",
    color: "var(--contentText)",
    text: "Draft",
    icon: null,
  },
  ACTIVE: {
    bg: "#25C277",
    color: "#ffffff",
    text: "Running",
    icon: ICONS?.Running,
  },
  RUNNING: {
    bg: "#25C277",
    color: "#ffffff",
    text: "Running",
    icon: ICONS?.Running,
  },
  PAUSED: {
    bg: "#FF7700",
    color: "#ffffff",
    text: "Paused",
    icon: ICONS?.Paused,
  },
  SCHEDULED: {
    bg: "#F6A723",
    color: "#ffffff",
    text: "Scheduled",
    icon: ICONS?.Running,
  },
  COMPLETED: {
    bg: "#4C90F5",
    color: "#ffffff",
    text: "Completed",
    icon: ICONS?.TickCircle,
  },
};

export const PREVIEW_CONTENTS = [
  {
    id: 1,
    title: "In App Preview",
    content:
      "Play the Sequence right here. Useful for checking message order, texts and making quick changes.",
    icon: SequencePreview,
    width: 24,
    height: 24,
  },
  {
    id: 2,
    title: "In WhatsApp Preview",
    content:
      "Test the Sequence in WhatsApp exactly as your customers see it. For final check before publishing.",
    icon: Whatsapp,
    width: 20,
    height: 20,
  },
];

export const TRIGGERS_ICONS = {
  CAMP_WAPP_BCAST: {
    icon: Broadcast,
    color: "#FFFFFF",
    bg: "#04B8A2",
  },
  CAMP_QR_URL: {
    icon: QRCode,
    color: "#FFFFFF",
    bg: "#FFC261",
  },
  "QR Code Scan": {
    icon: QRCode,
    color: "#FFFFFF",
    bg: "#FFC261",
  },
  "QR": {
    icon: QRCode,
    color: "#FFFFFF",
    bg: "#FFC261",
  },
  "API Trigger": {
    icon: WebhookIcon,
    color: "rgb(139, 92, 246)",
    bg: "#8B5CF6",
  },
  "Keyword Trigger": {
    icon: Key,
    color: "#FFFFFF",
    bg: "#D946EF",
  },
  BROADCAST: {
    icon: Broadcast,
    color: "#FFFFFF",
    bg: "#04B8A2",
  },
  WHATSAPP: {
    icon: Whatsapp,
    color: "#04B8A2",
    bg: "#ffffff",
  },
  FB: {
    icon: FB,
    color: "#FFFFFF",
    bg: "#0082FB",
  },
  "Meta Ads": {
    icon: Meta,
    color: "#FFFFFF",
    bg: "#0082FB",
  },
  INSTAGRAM: {
    icon: Instagram,
    color: "#FFFFFF",
    bg: "linear-gradient(45deg, #FFC107 9.15%, #F44336 50.57%, #9C27B0 90.03%)",
  },
  WEBSITE: {
    icon: Website,
    color: "#FFFFFF",
    bg: "#0082FB",
  },
  API_TRIGGER: {
    icon: WebhookIcon,
    color: "#FFFFFF",
    bg: "#8B5CF6",
  },
  KEYWORD_TRIGGER: {
    icon: Key,
    color: "#FFFFFF",
    bg: "#D946EF",
  },
  FOLLOW_UP: {
    icon: FollowUpTimer,
    color: "#FFFFFF",
    bg: "#D946EF",
  },
  ASSIGNEE: {
    icon: Assignee,
    color: "#FFFFFF",
    bg: "#6940F2",
    height: "2rem",
    width: "2rem",
  },
};

export const TRIGGERS = [
  {
    id: 1,
    title: "Triggers",
    list: [
      {
        id: 1,
        label: "Broadcast",
        text: "Engage your audience with sequences",
        key: "CAMP_WAPP_BCAST",
        disabled: false,
        warning: false,
        error: false,
        bg: "var(--primary)",
      },
    ],
  },
  {
    id: 2,
    title: "Suggested Triggers",
    list: [
      {
        id: 1,
        label: "QR Code Scan",
        text: "Bring users from the QR code scan",
        key: "CAMP_QR_URL",
        disabled: false,
        warning: false,
        error: false,
      },
      {
        id: 2,
        label: "Keyword Trigger",
        text: "Start sequence when specific keywords are received",
        key: "KEYWORD_TRIGGER",
        disabled: false,
        warning: false,
        error: false,
      },
      {
        id: 3,
        label: "Message via Post",
        text: "Response when a user message from Post",
        key: "fb",
        disabled: true,
        warning: false,
        error: false,
      },
      {
        id: 3,
        label: "Message via Profile",
        text: "Lorem ipsum dolor sit amet consectetu",
        key: "instagram",
        disabled: true,
        warning: false,
        error: false,
      },
      {
        id: 4,
        label: "Website",
        text: "Bring users from the website.",
        key: "website",
        disabled: true,
        warning: false,
        error: false,
      },
      {
        id: 5,
        label: "Message via Page",
        text: "Response when a user message from Page",
        key: "fb",
        disabled: true,
        warning: false,
        error: false,
      },
      {
        id: 6,
        label: "API Trigger",
        text: "Trigger sequence via API",
        key: "API_TRIGGER",
        disabled: false,
        warning: false,
        error: false,
      },
    ],
  },
  // {
  //   id: 3,
  //   title: "Ads Trigger",
  //   list: [
  //     {
  //       id: 1,
  //       label: "Meta Ads (CTWA)",
  //       labels: "Meta Ads",
  //       text: "Bring users from Facebook ads",
  //       key: "Meta Ads",
  //       disabled: false,
  //       warning: false,
  //       error: false,
  //     },
  //   ],
  // },
];

export const NODE_TYPES = {};

export const INITIAL_TRIGGER_DATA = {
  CAMP_WAPP_BCAST: {
    trigger_type: "CAMP_WAPP_BCAST",
    label: "Broadcast",
    component_type: "CUSTOM",
  },
  CAMP_QR_URL: {
    trigger_type: "CAMP_QR_URL",
    label: "QR",
    component_type: "CUSTOM",
  },
  API_TRIGGER: {
    trigger_type: "API_TRIGGER",
    label: "API Trigger",
    component_type: "CUSTOM",
  },
  KEYWORD_TRIGGER: {
    trigger_type: "KEYWORD_TRIGGER",
    label: "Keyword Trigger",
    component_type: "CUSTOM",
  },
};

export const INITIAL_NODE_COMPONENT_DATA = {
  CAMP_WAPP_BCAST: {
    broadcast_name: "",
  },
  CAMP_QR_URL: {
    QR: "",
    id: "",
    url: "",
    type: "QR",
    url_text: "",
    phone_number: {
      id: null,
      country_code: "",
      send_from_phone_name: "",
      send_from_phone_number: "",
      send_from_phone_number_id: "",
    },
  },
  API_TRIGGER: {
    type: "api_trigger",
    webhook_url: "",
    method: "POST",
    headers: {},
    payload_schema: {},
  },
  KEYWORD_TRIGGER: {
    type: "keyword_trigger",
    keywords: [],
    match_type: "exact",
    match_threshold: 80,
    case_sensitive: false,
  },
  TEXT: {
    type: "text",
    text: {
      link: "",
    },
  },
  VIDEO: {
    type: "video",
    video: {
      link: "",
    },
  },
  interactive: { type: "interactive" },
  list: {
    type: "list",
    template: [],
  },
  cta_url: {
    type: "cta_url",
    interactive: {
      body: {
        text: ""
      },
      action: {
        name: "cta_url",
        parameters: {
          display_text: "",
          url: ""
        }
      }
    }
  },
  flow: {
    type: "flow",
    interactive: {
      type: "flow",
      body: {
        text: ""
      },
      action: {
        name: "flow",
        parameters: {
          flow_message_version: "3",
          flow_cta: "View Flow",
          flow_name: "",
          flow_id: "",
          flow_identifier: ""
        }
      }
    }
  },
  template: {
    type: "template",
    template: [],
  },
  nudge: {},
  follow_up: {},
  CONTACTS: {
    type: "contacts",
    contacts: []
  }
};


export const ALLOWED_BODY_NODE_TYPES = ["TEXT", "BUTTON", "LIST", "LOCATION_REQUEST_MESSAGE", "CTA_URL","FLOW", "PAYMENT_CAPTURED", "PAYMENT_FAILED", "FLOW_COMPLETED"];
export const ALLOWED_FOOTER_NODE_TYPES = ["BUTTON", "LIST", "CTA_URL", "FLOW", "PAYMENT_CAPTURED", "PAYMENT_FAILED", "FLOW_COMPLETED"];
export const ALLOWED_BUTTONS_NODE_TYPES = ["BUTTON", "LIST", "CTA_URL", "FLOW", "PAYMENT_CAPTURED", "PAYMENT_FAILED", "FLOW_COMPLETED"];

export const ALLOWED_HEADER_NODE_TYPES = ["MEDIA", "BUTTON", "LIST", "FLOW", "CTA_URL", "FLOW_COMPLETED"];


export const INITIAL_NEW_BROADCAST_DATA = {
  isExisting: false,
  file: null,
  fileUrl: null,
  sendFrom: null,
  template: null,
  settings: null,
};

export const INITIAL_EXISTING_BROADCAST_DATA = {
  selectedBroadcast: null,
  isExisting: true,
};

export const SEND_MESSAGE_TYPES = [
  {
    id: 1,
    label: "Text Message",
    key: "text",
  },
  {
    id: 2,
    label: "Media Message",
    key: "media",
  },
  {
    id: 3,
    label: "Interactive Message",
    key: "interactive",
  },
  {
    id: 4,
    label: "List Message",
    key: "list",
  },
  {
    id: 5,
    label: "Template Message",
    key: "template",
  },
  {
    id: 6,
    label: "CTA URL Message",
    key: "cta_url",
  },
  {
    id: 7,
    label: "Flow Message",
    key: "flow",
  },
  {
    id: 8,
    label: "Contacts Message",
    key: "contacts",
  },
];

export const NONE_TYPE = {
  id: 1,
  label: "None",
  key: "NONE",
};

export const TEXT_TYPE = {
  id: 2,
  label: "Text",
  key: "TEXT",
};

export const IMAGE_TYPE = {
  id: 3,
  label: "Image",
  key: "IMAGE",
};

export const VIDEO_TYPE = {
  id: 4,
  label: "Video",
  key: "VIDEO",
};

export const AUDIO_TYPE = {
  id: 5,
  label: "Audio",
  key: "AUDIO",
};

export const DOCUMENT_TYPE = {
  id: 6,
  label: "Document",
  key: "DOCUMENT",
};

export const LOCATION_REQUEST_TYPE = {
  id: 7,
  label: "Location Request Message",
  key: "LOCATION_REQUEST_MESSAGE",
};

export const CTA_URL_TYPE = {
  id: 8,
  label: "CTA URL Message",
  key: "CTA_URL",
};

export const FLOW_TYPE = {
  id: 9,
  label: "Flow Message",
  key: "FLOW",
};

export const CONTACTS_TYPE = {
  id: 10,
  label: "Contacts Message",
  key: "CONTACTS",
};

export const MEDIA_TYPES = [IMAGE_TYPE, VIDEO_TYPE, AUDIO_TYPE, DOCUMENT_TYPE];

export const FOOTER_TYPES = [NONE_TYPE, TEXT_TYPE];

export const HEADER_DETAILS = {
  IMAGE: {
    label: "Drop a JPG or PNG here",
    note: "Image size should be less than 5MB",
    accept: ".jpg, .jpeg, .png",
  },
  VIDEO: {
    label: "Drop a MP4 video here",
    note: "Video size should be less than 16MB",
    accept: ".mp4",
  },
  DOCUMENT: {
    label: "Drop a PDF file here",
    note: "Document size should be less than 100MB",
    accept: ".pdf, .doc",
  },
  AUDIO: {
    label: "Drop an audio here",
    note: "Audio size should be less than 16MB",
    accept: ".mp3",
  },
};

export const DEFAULT_MEDIA_SIZE = {
  image: 160,
  video: 160,
  document: 160,
  audio: 45,
  text: 9,
};

export const SEQUENCE_ACTIVATION_RULES = {
  MIN_NODES: 1,
  MIN_EDGES: 1,
  REQUIRE_ACTIVE_TRIGGER: true
};

export const SEQUENCE_STATUS = {
  ACTIVE: 'ACTIVE',
  RUNNING: 'RUNNING',
  DRAFT: 'DRAFT',
  NEW: 'NEW',
  PAUSED: 'PAUSED',
  SCHEDULED: 'SCHEDULED',
  COMPLETED: 'COMPLETED'
};

export const maxButtonCount = 3;

export const BUTTON_TYPES = [
  NONE_TYPE,
  {
    id: 2,
    label: "Quick Reply",
    key: "QUICK_REPLAY",
  },
];
